<template>
  <v-row class="text-left full-height">
    <v-col cols="12">
      <v-card class="rounded-lg pa-3">
        <v-card-title class="font-weight-bold">Scheduled Jobs</v-card-title>
        <v-data-table
          :headers="columns"
          :items="tasks"
          item-key="endpoint"
          :items-per-page="-1"
          class="elevation-0 row-pointer table box-border"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.button`]="{ item }">
            <v-btn
              color="brandCyan"
              class="white--text"
              depressed
              @click="runCRON(item.endpoint)"
              :loading="tasksRunning.includes(item.endpoint)"
              >Run</v-btn
            >
          </template>
        </v-data-table>

        <div></div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import OnboardingService from "@/services/OnboardingService";
import GroupService from "@/services/GroupService";
import ContentService from "@/services/ContentService";
import CommunicationService from "@/services/CommunicationService";
import RobinService from "@/services/RobinService";
import WalletService from "@/services/WalletService";

import { mapState } from "vuex";

function initialState() {
  return {
    tasksRunning: [],
    columns: [
      {
        text: "Task name",
        align: "start",
        value: "name",
        width: "80%",
      },
      {
        text: "",
        align: "center",
        value: "button",
        width: "20%",
      },
    ],
    tasks: [
      {
        name: "Refresh groups",
        endpoint: "/refreshGroups",
      },
      {
        name: "Refresh video encoding",
        endpoint: "/content/encode/status",
      },
      {
        name: "Send new messages",
        endpoint: "/messgaes/cron/send",
      },
      {
        name: "Refresh Robin recommendations",
        endpoint: "/robin/cron/process",
      },
      {
        name: "Update email activity in Bigquery",
        endpoint: "/messgaes/cron/activity",
      },
      {
        name: "Update email activity that bounced in Bigquery",
        endpoint: "/messgaes/cron/bounces",
      },
      {
        name: "Update email activity that was blocked in Bigquery",
        endpoint: "/messgaes/cron/blocks",
      },
      {
        name: "Update email activity that went to spam in Bigquery",
        endpoint: "/messgaes/cron/spam",
      },

      {
        name: "Refreshes Stellar balances in Bigquery",
        endpoint: "/balance/cron/stellar",
      },
      {
        name: "Refreshes Marqeta balances in Bigquery",
        endpoint: "/balance/cron/marqeta/users",
      },
      {
        name: "Refreshes Marqeta program balance in Bigquery",
        endpoint: "/balance/cron/marqeta/program",
      },
    ],
  };
}
export default {
  name: "CRON",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return initialState();
  },
  created() {},
  beforeUnmount() {},
  methods: {
    resetPage() {
      Object.assign(this.$data, initialState());
    },
    runCRON(endpoint) {
      this.tasksRunning.push(endpoint);
      if (endpoint == "/refreshGroups") {
        GroupService.refreshGroupsV2().then((x) => {
          console.log("Refresh group response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/content/encode/status") {
        ContentService.refreshFileEncodingStatus().then((x) => {
          console.log("Content encoding response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/messgaes/cron/send") {
        console.log("CRON!");
        CommunicationService.sendMessageCRON().then((x) => {
          console.log("Message CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/messgaes/cron/activity") {
        console.log("CRON!");
        CommunicationService.updateEmailActivityCRON().then((x) => {
          console.log("Email Activity CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/messgaes/cron/bounces") {
        console.log("CRON!");
        CommunicationService.updateEmailBounceCRON().then((x) => {
          console.log("Email Bounce CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/messgaes/cron/blocks") {
        console.log("CRON!");
        CommunicationService.updateEmailBlockCRON().then((x) => {
          console.log("Email Block CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/messgaes/cron/spam") {
        console.log("CRON!");
        CommunicationService.updateEmailSpamCRON().then((x) => {
          console.log("Email Spam CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/robin/cron/process") {
        RobinService.processRecommendations().then((x) => {
          console.log("Robin CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/balance/cron/stellar") {
        WalletService.updateReportingBalancesStellar().then((x) => {
          console.log("Balance CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/balance/cron/marqeta/users") {
        WalletService.updateReportingBalancesMarqetaUsers().then((x) => {
          console.log("Balance CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      } else if (endpoint == "/balance/cron/marqeta/program") {
        WalletService.updateReportingBalancesProgramBalance().then((x) => {
          console.log("Balance CRON response: ", x);
          this.tasksRunning = this.tasksRunning.filter((id) => id !== endpoint);
        });
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "permissions"]),
  },
  watch: {},
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
